/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { BagCartEssentialDataFragmentDoc } from './BagCart.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ConvertToMultipartyOrderInput = {
  readonly multipartyOrderDetails: MultipartyDetailInput;
};

export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type LockOrderInput = {
  readonly reason: LockOrderReason;
};

/** The reason why the order is being locked */
export type LockOrderReason = 'CHANGE_LOCATION' | 'CHECKOUT';

export type ModifierType = 'ADDITION' | 'INCLUDED' | 'MIXED_DRESSING' | 'REMOVAL' | 'SUBSTITUTION';

export type MultipartyDetailInput = {
  readonly hostName: string;
};

export type OrderState =
  | 'Active'
  | 'Canceled'
  | 'Complete'
  | 'Discarded'
  | 'LockedChangeLocation'
  | 'LockedCheckout';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type BagLeaveGroupOrderMutationVariables = Exact<{ [key: string]: never }>;

export type BagLeaveGroupOrderMutation = {
  readonly leaveMultipartyOrder:
    | { readonly __typename: 'LeaveOrderSuccess'; readonly success: boolean }
    | { readonly __typename: 'MultipartyOrderNotFound'; readonly errorMessage: string }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string }
    | { readonly __typename: 'ValidationError'; readonly message: string };
};

export type BagConvertToGroupOrderMutationVariables = Exact<{
  input: Types.ConvertToMultipartyOrderInput;
}>;

export type BagConvertToGroupOrderMutation = {
  readonly convertToMultipartyOrder:
    | { readonly __typename: 'CartNotFound'; readonly errorMessage: string }
    | {
        readonly __typename: 'ConvertToMultipartyOrderSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: {
            readonly canApplyRewards: boolean;
            readonly canSubmitOrder: boolean;
            readonly canUpdateOrderDetails: boolean;
          };
          readonly multipartyDetails: { readonly joinCode: string } | null;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly entityId: number | null;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showOutpostPriceDifferenciationDisclosure: boolean;
            readonly showDeliveryPriceDifferenciationDisclosure: boolean;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly deliveryFee: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly canEdit: boolean;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly isModifiable: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
            readonly orderParticipant: {
              readonly id: string;
              readonly displayName: string | null;
              readonly isMe: boolean;
            } | null;
          }>;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
        };
      }
    | { readonly __typename: 'MultipartyOrderNotEnabled'; readonly errorMessage: string }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string }
    | { readonly __typename: 'UnauthorizedOrderModification'; readonly errorMessage: string };
};

export type BagLockGroupOrderMutationVariables = Exact<{
  input: Types.LockOrderInput;
}>;

export type BagLockGroupOrderMutation = {
  readonly lockOrder:
    | { readonly __typename: 'CartNotFound'; readonly errorMessage: string }
    | { readonly __typename: 'LockOrderFailed'; readonly errorMessage: string }
    | {
        readonly __typename: 'LockOrderSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: {
            readonly canApplyRewards: boolean;
            readonly canSubmitOrder: boolean;
            readonly canUpdateOrderDetails: boolean;
          };
          readonly multipartyDetails: { readonly joinCode: string } | null;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly entityId: number | null;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showOutpostPriceDifferenciationDisclosure: boolean;
            readonly showDeliveryPriceDifferenciationDisclosure: boolean;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly deliveryFee: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly canEdit: boolean;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly isModifiable: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
            readonly orderParticipant: {
              readonly id: string;
              readonly displayName: string | null;
              readonly isMe: boolean;
            } | null;
          }>;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
        };
      }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string };
};

export type BagUnlockGroupOrderMutationVariables = Exact<{ [key: string]: never }>;

export type BagUnlockGroupOrderMutation = {
  readonly unlockOrder:
    | { readonly __typename: 'CartNotFound'; readonly errorMessage: string }
    | { readonly __typename: 'UnlockOrderFailed'; readonly errorMessage: string }
    | {
        readonly __typename: 'UnlockOrderSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: {
            readonly canApplyRewards: boolean;
            readonly canSubmitOrder: boolean;
            readonly canUpdateOrderDetails: boolean;
          };
          readonly multipartyDetails: { readonly joinCode: string } | null;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly entityId: number | null;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showOutpostPriceDifferenciationDisclosure: boolean;
            readonly showDeliveryPriceDifferenciationDisclosure: boolean;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly deliveryFee: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly canEdit: boolean;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly isModifiable: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
            readonly orderParticipant: {
              readonly id: string;
              readonly displayName: string | null;
              readonly isMe: boolean;
            } | null;
          }>;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
        };
      };
};

export const BagLeaveGroupOrderDocument = gql`
  mutation BagLeaveGroupOrder {
    leaveMultipartyOrder {
      __typename
      ... on LeaveOrderSuccess {
        success
      }
      ... on MultipartyOrderNotFound {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
      ... on ValidationError {
        message
      }
    }
  }
`;

export function useBagLeaveGroupOrderMutation() {
  return Urql.useMutation<BagLeaveGroupOrderMutation, BagLeaveGroupOrderMutationVariables>(
    BagLeaveGroupOrderDocument,
  );
}
export const BagConvertToGroupOrderDocument = gql`
  mutation BagConvertToGroupOrder($input: ConvertToMultipartyOrderInput!) {
    convertToMultipartyOrder(input: $input) {
      __typename
      ... on ConvertToMultipartyOrderSuccess {
        order {
          ...BagCartEssentialData
        }
      }
      ... on CartNotFound {
        errorMessage
      }
      ... on MultipartyOrderNotEnabled {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
      ... on UnauthorizedOrderModification {
        errorMessage
      }
    }
  }
  ${BagCartEssentialDataFragmentDoc}
`;

export function useBagConvertToGroupOrderMutation() {
  return Urql.useMutation<BagConvertToGroupOrderMutation, BagConvertToGroupOrderMutationVariables>(
    BagConvertToGroupOrderDocument,
  );
}
export const BagLockGroupOrderDocument = gql`
  mutation BagLockGroupOrder($input: LockOrderInput!) {
    lockOrder(input: $input) {
      __typename
      ... on LockOrderSuccess {
        order {
          ...BagCartEssentialData
        }
      }
      ... on CartNotFound {
        errorMessage
      }
      ... on LockOrderFailed {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
    }
  }
  ${BagCartEssentialDataFragmentDoc}
`;

export function useBagLockGroupOrderMutation() {
  return Urql.useMutation<BagLockGroupOrderMutation, BagLockGroupOrderMutationVariables>(
    BagLockGroupOrderDocument,
  );
}
export const BagUnlockGroupOrderDocument = gql`
  mutation BagUnlockGroupOrder {
    unlockOrder {
      __typename
      ... on UnlockOrderSuccess {
        order {
          ...BagCartEssentialData
        }
      }
      ... on CartNotFound {
        errorMessage
      }
      ... on UnlockOrderFailed {
        errorMessage
      }
    }
  }
  ${BagCartEssentialDataFragmentDoc}
`;

export function useBagUnlockGroupOrderMutation() {
  return Urql.useMutation<BagUnlockGroupOrderMutation, BagUnlockGroupOrderMutationVariables>(
    BagUnlockGroupOrderDocument,
  );
}
